/**
 * Procedure Categories and Procedures for MD in Physiology students
 * Extracted with strict evidence from official NMC PDF (Page 8-11: "must PERFORM independently")
 */
export const PHYSIOLOGY_PROCEDURES = {
  "Hematological Profile Procedures": [
    "Estimation of Hemoglobin",
    "Determination of Total Erythrocyte (RBC) Count & RBC Indices",
    "Determination of Total Leucocyte Count (TLC)",
    "Preparation of Peripheral Blood Smear & Differential Leucocyte Count (DLC)",
    "Determination of Arneth Count",
    "Determination of Bleeding Time (BT) and Clotting Time (CT)",
    "Determination of ABO and Rh Blood Groups",
    "Determination of Erythrocyte Sedimentation Rate (ESR) & Packed Cell Volume (PCV)",
    "Determination of Osmotic Fragility of Red Blood Cells",
    "Determination of Platelet Count",
    "Determination of Reticulocyte Count",
  ],
  "Cardio-Respiratory & Neuro-Physiological Testing": [
    "Ergography & Hand Grip Spring Dynamography",
    "Recording of Electromyography (EMG) and Nerve Conduction",
    "Measurement of Arterial Blood Pressure & Effect of Head-Up / Head-Down Tilt",
    "Recording of 12-Lead Electrocardiography (ECG) and Interpretation",
    "Measurement of Blood Flow",
    "Heart Rate Variability Assessment",
    "Ambulatory Blood Pressure Monitoring",
    "Stethography (Recording of Respiratory Movements)",
    "Assessment of Respiratory Functions (Spirometry, Vitalography, and Gas Analysis)",
    "Measurement of Basal Metabolic Rate (BMR)",
    "Cardiopulmonary Resuscitation (CPR) & Artificial Respiration",
    "Recording of Body Temperature & Effect of Thermal Exposure",
    "Determination of Ovulation Time (Basal Body Temperature & Immunological Tests)",
    "Semen Analysis (Sperm Count, Motility, and Sperm Morphology)",
    "Perimetry (Mapping Out of Visual Field and Blind Spot)",
    "Testing for Colour Vision and Colour Blindness",
    "Determination of Visual/Auditory Reaction Time & Reflex Time",
    "Electroencephalography (EEG) and Polysomnography Recording",
    "Autonomic Nervous System (ANS) Testing",
    "Neuro-Electrodiagnostic Techniques (VEP, BAEP, SEP, MEP)",
    "Psychological Test Batteries Evaluation",
    "Physical Fitness & Exercise Stress Testing (Body Composition, Bicycle Ergometry, Treadmill VO2 Max, Harvard Step Test)",
    "Recording Effect of Yoga and Pranayama on Physiological Parameters",
    "Construction of Dietary Chart",
    "Basic Life Support (BLS) and Cardiac Life Support (CLS)",
  ],
  "Simulated Amphibian (Frog) Experiments": [
    "Effect of Temperature on Simple Muscle Twitch",
    "Effect of Two Successive Stimuli on Skeletal Muscle",
    "Effect of Increasing Strength of Stimuli on Skeletal Muscle",
    "Effect of Increasing Frequency of Stimuli (Genesis of Tetanus)",
    "Effect of Free Load and After Load on Skeletal Muscle",
    "Effect of Repeated Stimuli (Study of Fatigue)",
    "Study of Isometric Contraction in Skeletal Muscle",
    "Determination of Conduction Velocity of Sciatic Nerve",
    "Properties of Cardiac Muscle (Refractory Period, All-or-None Law, Extra Systole)",
    "Regulation of Heart & Vagus Dissection",
    "Effect of Physiological and Pharmacological Variables on Frog's Heart",
    "Perfusion of Isolated Frog's Heart",
  ],
};

export const PHYSIOLOGY_CATEGORIES = Object.keys(PHYSIOLOGY_PROCEDURES);

export const isMDInPhysiologyDept = (department) => {
  if (!department) {
    try {
      const u = JSON.parse(
        localStorage.getItem("userData") || localStorage.getItem("user") || "{}"
      );
      department = u.department || (u.departments && u.departments[0]);
    } catch (e) {}
  }
  if (!department) return false;
  const d = String(department).toLowerCase();
  return d.includes("physiology");
};

